<template>
  <div><EmailStep></EmailStep></div>
</template>
<script>
import BodyClass from "../mixins/BodyClass";
import PageTitle from "../mixins/PageTitle";
import EmailStep from "../components/selfRegisteration/EmailStep.vue";
import PasswordStep from "../components/selfRegisteration/PasswordStep.vue";
export default {
  name: "SelfRegistration",
  mixins: [BodyClass, PageTitle],
  components: { EmailStep,PasswordStep},
  data() {},
  methods: {},
}
</script>
<style scoped>
</style>